import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const modelsListRouteRef = createRouteRef();

export const sessionDetailsRouteRef = createRouteRef({
  params: ['sessionId'],
});

export const modelDetailsRouteRef = createRouteRef({
  params: ['modelId'],
});
